import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import getTextMessagingAccountOperation from 'owa-service/lib/operation/getTextMessagingAccountOperation';
import getTextMessagingAccountRequest from 'owa-service/lib/factory/getTextMessagingAccountRequest';
import GetTextMessagingAccountResponse from 'owa-service/lib/contract/GetTextMessagingAccountResponse';

export default async function getTextMessagingAccountService() {
    return await getTextMessagingAccountOperation(
        getTextMessagingAccountRequest({
            Header: getJsonRequestHeader(),
        }),
        {
            datapoint: {
                jsonCustomData: (json: GetTextMessagingAccountResponse) => ({
                    error: json?.WasSuccessful ? json.ErrorMessage : '',
                }),
            },
        }
    );
}
